import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { useTheme } from '@material-ui/core';
import ChartImager from '../../../components/ChartImager';

const ManagedAssetsByDate = ({ report, setB64Img }) => {
  const theme = useTheme();

  const CONFIG = {
    options: {
      scales: {
        yAxes: [
          {
            display: true,
            ticks: {
              suggestedMin: 0,
            },
          },
        ],
      },
      animation: {
        duration: 0,
      },
    },
  };

  const ds = {
    datasets: [
      {
        label: 'Managed Assets By Date',
        data: Object.values(report.managedAssetsByDate),
        backgroundColor: theme.palette.primary.main,
      },
    ],
    labels: Object.keys(report.managedAssetsByDate),
  };
  return (
    <ChartImager
      callback={setB64Img}
      ChartComponent={Bar}
      data={ds}
      options={CONFIG.options}
    />
  );
};

ManagedAssetsByDate.propTypes = {
  report: PropTypes.object.isRequired,
  setB64Img: PropTypes.func.isRequired,
};

export default ManagedAssetsByDate;
